import React from "react";

function RegularMemership({
  clickedRowValue,
  wtfShare,
  gymShare,
  gstWtfFacilities,
  billRaised,
  netCashFlowWTF,
  netCashFlowGym,
}) {
  return (
    <div className="tableContainer">
      {clickedRowValue.is_gym_gst === 0 ? (
        <table className="table">
          <thead>
            <tr>
              <th scope="col" className="tableHead">
                Particulars
              </th>
              <th scope="col" className="tableHead">
                WTF Share
              </th>
              <th scope="col" className="tableHead">
                Gym share
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th className="tableData tdBolder">Gross Revenue</th>
              <td className="tableData">-</td>
              <td className="tableData">
                ₹{clickedRowValue.gross_revenue || "0"}
              </td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Online</th>
              <td className="tableData">-</td>
              <td className="tableData">₹{clickedRowValue.online || "0"}</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Cash</th>
              <td className="tableData">-</td>
              <td className="tableData">₹{clickedRowValue.cash || "0"}</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Bank Charges(Online*2.5%)</th>
              <td className="tableData">-</td>
              <td className="tableData">
                ₹{clickedRowValue.gateway_charges || "0"}
              </td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Pre GST Amount</th>
              <td className="tableData">
                ₹
                {`${clickedRowValue.pre_GST_amount}( Gross Revenue/1.18)` ||
                  "0"}
              </td>
              <td className="tableData">-</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">GST</th>
              <td className="tableData">-₹{clickedRowValue.gst || "0"}</td>
              <td className="tableData">-</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">
                Net Revenue(Pre GST - Bank Charges)
              </th>
              <td className="tableData">-</td>
              <td className="tableData">
                ₹{clickedRowValue.net_revenue || "0"}
              </td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Gym Owner CTO (Settled)</th>
              <td className="tableData">-</td>
              <td className="tableData">
                ₹{Math.round(clickedRowValue.settled_cto_gym) || "0"}
              </td>
            </tr>

            <tr>
              <th className="tableData tdBolder">WTF CTO (Settled)</th>
              <td className="tableData">
                ₹{clickedRowValue.settled_cto_wtf || "0"}
              </td>
              <td className="tableData">-</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Net Cash Flow at PAGL</th>
              <td className="tableData">-</td>
              <td className="tableData">₹{clickedRowValue.gst || "0"}</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">
                Net Cash Flow at PAGL(AFTER CTO)
              </th>
              <td className="tableData">-</td>
              <td className="tableData">
                ₹{clickedRowValue.sharable_amount || "0"}
              </td>
            </tr>
            <tr>
              <th className="tableData tdBolder">WTF Share</th>
              <td className="tableData">-</td>
              <td className="tableData">₹{wtfShare || "0"}</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Gym Share</th>
              <td className="tableData">-</td>
              <td className="tableData">₹{gymShare || "0"}</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">
                GST on WTF Facilitation Services
              </th>
              <td className="tableData">-</td>
              <td className="tableData">₹{gstWtfFacilities || "0"}</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Bill Raised to GYM</th>
              <td className="tableData">-</td>
              <td className="tableData">₹{billRaised || "0"}</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">GST Paid to Govt.</th>
              <td className="tableData">
                -₹{clickedRowValue.gstWtfFacilities || "0"}
              </td>
              <td className="tableData">-</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Net cash flow</th>
              <td className="tableData">₹{netCashFlowWTF}</td>
              <td className="tableData">₹{netCashFlowGym}</td>
            </tr>
          </tbody>
        </table>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th scope="col" className="tableHead">
                Particulars
              </th>
              <th scope="col" className="tableHead">
                WTF Share
              </th>
              <th scope="col" className="tableHead">
                Gym share
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th className="tableData tdBolder">Gross Revenue</th>
              <td className="tableData">
                ₹{clickedRowValue.gross_revenue || "0"}
              </td>
              <td className="tableData">-</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Online</th>
              <td className="tableData">₹{clickedRowValue.online || "0"}</td>
              <td className="tableData">-</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Cash</th>
              <td className="tableData">₹{clickedRowValue.cash || "0"}</td>
              <td className="tableData">-</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Bank Charges(Online*2.5%)</th>
              <td className="tableData">
                ₹{clickedRowValue.gateway_charges || "0"}
              </td>
              <td className="tableData">-</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Pre GST Amount</th>
              <td className="tableData">-</td>
              <td className="tableData">
                ₹
                {`${clickedRowValue.pre_GST_amount}( Gross Revenue/1.18)` ||
                  "0"}
              </td>
            </tr>
            <tr>
              <th className="tableData tdBolder">GST</th>
              <td className="tableData">-</td>
              <td className="tableData">-₹{clickedRowValue.gst || "0"}</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">
                Net Revenue(Pre GST - Bank Charges)
              </th>
              <td className="tableData">
                ₹{clickedRowValue.net_revenue || "0"}
              </td>
              <td className="tableData">-</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Gym Owner CTO (Settled)</th>
              <td className="tableData">
                ₹{clickedRowValue.settled_cto_gym || "0"}
              </td>
              <td className="tableData">-</td>
            </tr>

            <tr>
              <th className="tableData tdBolder">WTF CTO (Settled)</th>
              <td className="tableData">-</td>
              <td className="tableData">
                ₹{clickedRowValue.settled_cto_wtf || "0"}
              </td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Net Cash Flow at PAGL</th>
              <td className="tableData">₹{clickedRowValue.gst || "0"}</td>
              <td className="tableData">-</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">
                Net Cash Flow at PAGL(AFTER CTO)
              </th>
              <td className="tableData">
                ₹{clickedRowValue.sharable_amount || "0"}
              </td>
              <td className="tableData">-</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">WTF Share</th>
              <td className="tableData">₹{wtfShare || "0"}</td>
              <td className="tableData">-</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Gym Share</th>
              <td className="tableData">₹{gymShare || "0"}</td>
              <td className="tableData">-</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">
                GST on WTF Facilitation Services
              </th>
              <td className="tableData">₹{gstWtfFacilities || "0"}</td>
              <td className="tableData">-</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Bill Raised to GYM</th>
              <td className="tableData">₹{billRaised || "0"}</td>
              <td className="tableData">-</td>
            </tr>
            <tr>
              <th className="tableData tdBolder">GST Paid to Govt.</th>
              <td className="tableData">-</td>
              <td className="tableData">
                -₹{clickedRowValue.gstWtfFacilities || "0"}
              </td>
            </tr>
            <tr>
              <th className="tableData tdBolder">Net cash flow</th>
              <td className="tableData">₹{netCashFlowWTF}</td>
              <td className="tableData">₹{netCashFlowGym}</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
}

export default RegularMemership;
